













































































import { defineComponent, PropType, toRefs, computed } from '@vue/composition-api';
import {
  ACTION_TYPE,
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  AcoFormData,
  PixelInfo,
} from '@tt4b/ttam-enums';

import Tracking from '../index';
import TtamAdTrackingWebsiteEventsComposeRefactored from '../tracking-website-events-compose-refactored.vue';
import { AppDataItem } from '../types';

const name = 'ttam-tiktok-event-tracking';
export default defineComponent({
  name,
  components: {
    TtamTrackingPixelTips: Tracking.TtamTrackingPixelTips,
    TtamTrackingPixelEcho: Tracking.TtamTrackingPixelEcho,
    TtamTrackingPixelSelect: Tracking.TtamTrackingPixelSelect,
    TtamAdTrackingAppEventsCompose: Tracking.TtamAdTrackingAppEventsCompose,
    TtamCreativeTrackOfflineEvents: Tracking.TtamCreativeTrackOfflineEvents,
    TtamAdTrackingWebsiteEventsComposeRefactored,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({} as FullNormalFormData),
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String as PropType<typeof ACTION_TYPE[keyof typeof ACTION_TYPE]>,
      default: ACTION_TYPE.CREATE,
    },
    copyNum: {
      type: Number,
      default: 20,
    },
    adGroupPixelInfo: {
      type: Object as PropType<PixelInfo>,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    isShowWebsiteEvents: {
      type: Boolean,
      default: false,
    },
    isShowAppEvents: {
      type: Boolean,
      default: false,
    },
    isShowOfflineEvents: {
      type: Boolean,
      default: false,
    },
    isRetargetingApp: {
      type: Boolean,
      default: false,
    },
    trackUrlCreativeConfig: {
      type: Object,
      default: () => ({}),
    },
    isNewTiktokEventTrack: {
      type: Boolean,
      defalut: false,
    },
    isOnlyShowImpressionUrl: {
      type: Boolean,
      defalut: false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, creativeData, createMode, isShowOfflineEvents, isNewTiktokEventTrack } = toRefs(props);

    const {
      isSupportDomain,
      isShowPcmDrop: pcmDropTipVisible,
      isDomainNotMatch: domainNotMatchTipVisible,
      domainComputed,
      trackingOptions,
      pixelLabel,
    } = Tracking.usePixelDomainProps({
      adgroupData,
      creativeData,
      createMode,
    });

    const isAdgroupNoSelectPixel = computed(() => isNewTiktokEventTrack.value && !adgroupData.value.adRefPixelId);

    const _pixel = computed({
      get: () => domainComputed.value,
      set: (val: string) => emit('change', { domain: [val] }),
    });

    const onChangeTrackingOfflineEvent = val => {
      if (isShowOfflineEvents.value) {
        emit('change', val);
      }
    };

    const onChangeTrackingPixel = (id: string) => {
      emit('change', {
        trackingPixelId: id,
      });
    };
    const onChangeTrackingApp = (info: AppDataItem) => {
      if (info?.Id) {
        emit('change', {
          trackingAppId: info?.Id || '0',
          trackingAppInfo: info,
        });
      } else {
        emit('change', {
          trackingAppId: '0',
          trackingAppInfo: {},
        });
      }
    };
    const onChangeAppInfo = (info: AppDataItem) => {
      if (info?.Id) {
        emit('change', {
          trackingAppInfo: info,
        });
      } else {
        emit('change', {
          trackingAppInfo: {},
        });
      }
    };
    return {
      name,
      isSupportDomain,
      pcmDropTipVisible,
      domainNotMatchTipVisible,
      domainComputed,
      trackingOptions,
      pixelLabel,
      isAdgroupNoSelectPixel,

      _pixel,
      onChangeTrackingPixel,
      onChangeTrackingApp,
      onChangeAppInfo,
      onChangeTrackingOfflineEvent,
    };
  },
});
